export const ArrowDown = ({ rotation = 0, ...props }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotation}deg)`,
        transition: "transform 0.2s ease-in-out",
      }}
      {...props}
    >
      <path
        d="M14.1666 8.14166C14.0104 7.98646 13.7992 7.89934 13.5791 7.89934C13.3589 7.89934 13.1477 7.98646 12.9916 8.14166L9.99992 11.0917L7.04992 8.14166C6.89378 7.98646 6.68257 7.89934 6.46242 7.89934C6.24226 7.89934 6.03105 7.98646 5.87492 8.14166C5.79681 8.21913 5.73481 8.3113 5.69251 8.41285C5.6502 8.5144 5.62842 8.62332 5.62842 8.73333C5.62842 8.84334 5.6502 8.95226 5.69251 9.05381C5.73481 9.15536 5.79681 9.24753 5.87492 9.325L9.40825 12.8583C9.48572 12.9364 9.57789 12.9984 9.67944 13.0407C9.78098 13.083 9.88991 13.1048 9.99992 13.1048C10.1099 13.1048 10.2188 13.083 10.3204 13.0407C10.4219 12.9984 10.5141 12.9364 10.5916 12.8583L14.1666 9.325C14.2447 9.24753 14.3067 9.15536 14.349 9.05381C14.3913 8.95226 14.4131 8.84334 14.4131 8.73333C14.4131 8.62332 14.3913 8.5144 14.349 8.41285C14.3067 8.3113 14.2447 8.21913 14.1666 8.14166Z"
        fill="currentColor"
      />
    </svg>
  );
};
